import { sendMultiPartRequest } from 'services/base/sendRequest';
import { config } from '../../../config';
import { parseFetchError } from '../../../utils/http';
import {
  getStoredToken,
  sessionChecker,
  sessionCloser,
} from '../SessionChecker';

const home = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.userAdmin.prefix +
          config.api_routes.modules.userAdmin.services.home;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        if (dataOut.respCode === -5) {
          document.location.href = config.appURI;
        }
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser();
  }
};

const addUser = data => {
  const serviceUrl =
    config.serverURL +
    config.api_routes.prefix +
    config.api_routes.modules.userAdmin.prefix +
    config.api_routes.modules.userAdmin.services.add;

  let formData = new FormData();

  formData.append('email', data.email);
  formData.append('firstName', data.firstName);
  formData.append('lastName', data.lastName);
  formData.append('documentType', JSON.stringify(data.documentType));
  formData.append('documentNumber', data.documentNumber);
  formData.append('address', data.address);
  formData.append('city', JSON.stringify(data.city));
  formData.append('cellPhoneNumber', data.cellPhoneNumber);
  formData.append('role', JSON.stringify(data.role));
  formData.append('state', data.state);

  return sendMultiPartRequest(serviceUrl, formData);
};

const editUser = id => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.userAdmin.prefix +
          config.api_routes.modules.userAdmin.services.edit;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({ id }),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser();
  }
};

const updateUser = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.userAdmin.prefix +
          config.api_routes.modules.userAdmin.services.update;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser();
  }
};

const deleteUser = data => {
  const token = getStoredToken();
  if (token && token !== 'undefined') {
    return new Promise(async (resolve, reject) => {
      try {
        const serviceUrl =
          config.serverURL +
          config.api_routes.prefix +
          config.api_routes.modules.userAdmin.prefix +
          config.api_routes.modules.userAdmin.services.delete;
        const res = await fetch(serviceUrl, {
          headers: {
            'Access-Control-Allow-Origin': config.serverDomain,
            'Access-Control-Allow-Headers':
              'Origin, X-Requested-With, Content-Type, Accept',
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: config.jwtTokenStoreName + ' ' + token,
          },
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify(data),
        });
        const dataOut = await res.json();
        sessionChecker(dataOut);
        resolve(dataOut);
      } catch (e) {
        reject({
          respCode: -1,
          message: parseFetchError(e),
        });
      }
    });
  } else {
    return sessionCloser();
  }
};

export { home, addUser, editUser, updateUser, deleteUser };
